/* eslint-disable react/no-array-index-key */
import React from 'react';

import RenderToRoot from 'utils/RenderToRoot';

import Card from 'components/base/Card';
import CardHeader from 'components/base/CardHeader';
import CardBody from 'components/base/CardBody';
import Label from 'components/base/Label';
import Button from 'components/base/Button';
import Input from 'components/base/Input';
import Link from 'components/base/Link';

const LoginPage = () => {
  const formRef = React.useRef(null);

  return (
    <Card className="mt-2">
      <CardHeader>
        <h6>Log in with your Shoebox account</h6>
      </CardHeader>
      <CardBody>
        <p className="mb-4 text-sm text-gray-600">
          Use your <Link href="https://shoebox.gg">shoebox.gg</Link> credentials to log in.
          Don&apos;t have an account?{' '}
          <Link href="https://shoebox.gg">Create one at shoebox.gg</Link>.
        </p>
        <form action="/user/login" method="post" ref={formRef}>
          <Label>Email</Label>
          <Input id="email" name="email" type="text" />
          <Label>Password</Label>
          <Input id="password" type="password" name="password" />
          <Button outline color="primary" className="mt-3" loading onClick={() => formRef.current.submit()}>
            Login
          </Button>
        </form>
      </CardBody>
    </Card>
  );
};

export default RenderToRoot(LoginPage);
